import { render, staticRenderFns } from "./ShipmentCalendar.vue?vue&type=template&id=8fb510a6&scoped=true&"
import script from "./ShipmentCalendar.vue?vue&type=script&lang=js&"
export * from "./ShipmentCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentCalendar.vue?vue&type=style&index=0&id=8fb510a6&prod&scoped=true&lang=scss&"
import style1 from "./ShipmentCalendar.vue?vue&type=style&index=1&id=8fb510a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb510a6",
  null
  
)

export default component.exports